import React from 'react';

const About = () => {
  return (
    <div>
      <div>
        <h1>About the app</h1>
        <p>
          Locate github is a quick-github-profile lookup app using Github API.
        </p>
        <p>Verson 2.1 - using react.js</p>
      </div>
    </div>
  );
};

export default About;
